import React from 'react'

import './index.css'

const BlogItem = ({blog}) => {
  const {title, description, publishedDate} = blog
  return (
    <li className="blog-item">
      <h2 className="blog-title">{title}</h2>
      <p className="blog-description">{description}</p>
      <p className="blog-date">{publishedDate}</p>
    </li>
  )
}

export default BlogItem
